// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2dqmG","approved":"Status_approved__1b9LU","rejected":"Status_rejected__3w5ng","expired":"Status_expired__vw7jy","label":"Status_label__2DkQU"};